import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import MatrixView from '../../../../components/MatrixQuestion/MatrixView'
import { selectViewActions } from '../../modules/Clinro'

function ClinroMatrixView(props) {
  const { updateClinroMatrixQuestionLabel, ...rest } = props
  return <MatrixView {...rest} updateMatrixQuestionLabel={updateClinroMatrixQuestionLabel} />
}

ClinroMatrixView.propTypes = {
  updateClinroMatrixQuestionLabel: PropTypes.func.isRequired,
}

export default connect(null, selectViewActions)(ClinroMatrixView)
